import React from 'react';
import { makeStyles} from '@material-ui/core/styles';
// import Typography from '@material-ui/core/Typography';
import Sidebar from '../component/Sidebar';
import Bread from '../component/Breadcrumbs';
// const drawerWidth = 240;

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
  },
  toolbar: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    padding: theme.spacing(0, 1),
    // necessary for content to be below app bar
    ...theme.mixins.toolbar,
  },
  content: {
    flexGrow: 1,
    padding: theme.spacing(3),
  },
}));

export default function NotFound() {
  const classes = useStyles();
  return (
    <div className={classes.root}>
      <Sidebar />
      <main className={classes.content}>
      <div className={classes.toolbar} />
      <Bread />
       <h1>404 Not Found</h1>
      </main>
    </div>
    
   
  );
}


// WEBPACK FOOTER //
// ./src/Pages/NotFound.js